"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.percentageComplete = exports.makeDurationCounter = exports.makeTimeCode = exports.convertSeconds = exports.pad = void 0;

var pad = function pad(number, size) {
  var s = String(parseInt(number));

  while (s.length < (size || 2)) {
    s = "0" + s;
  }

  return s;
};

exports.pad = pad;

var convertSeconds = function convertSeconds(seconds) {
  var d, h, m, s;
  s = seconds;
  m = Math.floor(s / 60);
  s = s % 60;
  h = Math.floor(m / 60);
  m = m % 60;
  d = Math.floor(h / 24);
  h = h % 24;
  return {
    d: d,
    h: h,
    m: m,
    s: s
  };
};

exports.convertSeconds = convertSeconds;

var makeTimeCode = function makeTimeCode(seconds) {
  var c = convertSeconds(seconds);
  var timeComponents;

  if (c.h <= 0) {
    timeComponents = [c.m, c.s];
  } else {
    timeComponents = [c.h, c.m, c.s];
  }

  return timeComponents.map(function (t) {
    return pad(t, 2);
  }).join(':');
};

exports.makeTimeCode = makeTimeCode;

var makeDurationCounter = function makeDurationCounter(current, overall) {
  var timeComponents = [makeTimeCode(current), makeTimeCode(overall)];
  var displayTime = timeComponents.join(' / ');
  return displayTime;
};

exports.makeDurationCounter = makeDurationCounter;

var percentageComplete = function percentageComplete(currentTime, duration) {
  var percentage = Math.floor(100 / duration * currentTime);
  return percentage;
};

exports.percentageComplete = percentageComplete;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/distribution/time-code-helpers.js
// module id = 485
// module chunks = 0